<form class="form-inline">
    <span [innerHTML]="'SB_Report' | translate"></span> :

    @if (!isLoading && reportList) {
        <select [(ngModel)]="selectedReport"
                name="reportId"
                (ngModelChange)="selectReport()"
                class="form-control">
            <option value="" [innerHTML]="'SB_Select_Report' | translate"></option>
            @for (report of reportList; track report.id) {
                <option [ngValue]="report.id">{{ report.name }}</option>
            }
        </select>
    }

    <button class="btn btn-default" type="button" (click)="print()">
        <sb-icon name="print"></sb-icon>
        <span [innerHTML]="'SB_Print' | translate"></span>
    </button>

    <button class="btn btn-default" type="button" (click)="refresh()">
        <sb-icon name="refresh"></sb-icon>
        <span [innerHTML]="'SB_Refresh' | translate"></span>
    </button>

    <button class="btn btn-default" type="button" (click)="fullScreen()">
        <sb-icon name="fullScreen"></sb-icon>
        <span [innerHTML]="'SB_Full_Screen' | translate"></span>
    </button>

    @if (isLoading < 1 && reportList.length === 0) {
        <div>
            <span [innerHTML]="'SB_No_Reports_Available' | translate"></span>
        </div>
    }
</form>

@if (isLoading > 0) {
    <div class="col-xs-12 col-md-12 rhythm-m-t-2 loading">
        <sb-icon name="loading"></sb-icon>
        <span [innerHTML]="'SB_Loading' | translate"></span>
    </div>
}
